import React from 'react';
import PropTypes from 'prop-types';
import {
  FDBox,
  FDCardContent,
  FDPaper,
  FDStack,
  FDTitleText,
} from '@facet-wealth/design';
import { CashFlowItems } from 'Views/Page/Content/Templates/CashFlowMDCPageTemplate/CashFlowItems';

export const CashFlowSection = ({
  sectionResource,
  onEditItemClick,
}) => {
  return (
    <FDPaper maxWidth={'500px'} width={'100%'}>
      <FDBox paddingX={2} paddingY={1}>
        <FDStack justifyContent={'space-between'}>
          <FDTitleText value={sectionResource.selectedOptionPrompt('sectionName')} />
          <FDTitleText value={sectionResource.attr('total')} data-test={`${sectionResource.attr('sectionName')}-total`} />
        </FDStack>
      </FDBox>
      <FDCardContent>
        <CashFlowItems
          lineItemsCollection={sectionResource.attr('items')}
          onEditItemClick={onEditItemClick}
          emptyTitle={sectionResource.attr('emptyStateHeader')}
          emptyDescription={`Add your ${sectionResource.selectedOptionPrompt('sectionName').toLowerCase()} to start seeing your full financial picture.`}
        />
      </FDCardContent>
    </FDPaper>
  );
};

CashFlowSection.propTypes = {
  sectionResource: PropTypes.object.isRequired,
  onEditItemClick: PropTypes.func.isRequired,
};
